<script setup>
import {mdiAccountInjuryOutline, mdiRun} from "@mdi/js";

const emit = defineEmits(['displayIdentificationWizard', 'displayTriageWizard'])
</script>
<template>
    <v-col cols="12" md="6">
        <v-btn :text="pgettext('label', 'Add Patient')"
               color="red"
               block
               class="font-weight-bold"
               size="x-large"
               :prepend-icon="mdiAccountInjuryOutline"
               @click="emit('displayTriageWizard', null)"></v-btn>
    </v-col>
    <v-col cols="12" md="6">
        <v-btn :text="pgettext('label', 'Add Uninjured')"
               block
               class="font-weight-bold"
               size="x-large"
               :prepend-icon="mdiRun"
               color="success"
               @click="emit('displayIdentificationWizard', {skipTic: true})"></v-btn>
    </v-col>
</template>